module.exports = __webpack_public_path__ + "img/telex-logo.01984db8.png";